import { Checkbox } from '@mantine/core';
import B2BButton from '../../common/B2BButton';
import './Policy.css';
import { createB2BAPI } from '../../../api/Interceptor';
import { useMemo, useState } from 'react';
import _, { get } from 'lodash';
import { useLocation, useNavigate } from "react-router-dom";

export default function Policy({ cartData, cartInfo, priceSlab,profile,loyalty,  handleNextStep, combo, uom }) {
    const navigate = useNavigate();

    const [contentFullyViewed, setContentFullyViewed] = useState(false);
    const [checkboxCheck, setCheckboxCheck] = useState(false);
    const [deliveryModeError, setDeliveryModeError] = useState(false);
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);



    window.addEventListener('scroll', function () {
        const scrollPosition = window?.scrollY + window?.innerHeight;
        const divElement = document?.getElementById('fi');
        const divHeight = divElement?.offsetHeight;
        const divTop = divElement?.offsetTop;
        const divBottom = divTop + divHeight;

        if (scrollPosition >= divBottom) {
            setContentFullyViewed(true);
        }
    });


    const getCartType = () => {
        if (cartData[0]?.cartType === 'SAMPLE') {
            return 'Sample Cart'
        } else if (cartData[0]?.cartType === 'SWATCH') {
            return 'Swatch Cart'
        } else if (combo) {
            return 'Wholesale Cart'
        } else {
            return 'Wholesale Cart'
        }
    }


    const handleCheckboxChange = () => {
        setCheckboxCheck(prev => {
            const newCheckedState = !prev;
            if (newCheckedState) setDeliveryModeError(false);
            return newCheckedState;
        });
    };

    const handleButtonClick = () => {
        if (checkboxCheck) {
            setDeliveryModeError(false);
            handleNextStep();
        }
        else {
            setDeliveryModeError(true);
        }
    }
    const subtotall = cartData.reduce((sum, item) => {
        if (item.combo) {
            const qty = item.combo.quantity * (item.variants?.length || 0);
            const unitPrice = Number(item.combo.sellingPrice) || 0;
            const rib = item?.variants?.map((v) => {
                const ribItem = v?.ribItem;
                if (ribItem && ribItem.sellingPrice && ribItem.quantity) {
                    return ribItem.sellingPrice * ribItem.quantity;
                }
                return 0;
            });

            const ribTotal = _.sum(rib);
            return sum + qty * unitPrice + ribTotal;
        } else {
           
            const unitPrice = item.sellingPrice ;
            const rib = item?.ribItem?.sellingPrice * item?.ribItem?.quantity || 0;
            return sum + unitPrice * item.quantity + rib;
        }
    }, 0);
    return (
        <>
            <div className='f-32 f-700 m-b-20 m-t-48' id="return-policy-india">Policy</div>
            <div className='adaptive-layout boundary-width-992 checkout-layout' style={{ gap: '24px' }}>
                <div className='first' id="fi">
                    <div className='view-checkout-policies terms-policies checkout-route-view'>
                        <div className='policies'>
                            <div className='policy-cautious-return section-policy checkout-section-box'>
                                <div className='p-header flex-row items-center'>
                                    <div>Return & Cancellation</div>
                                </div>

                                <div className='p'>
                                    <li>
                                        <strong className="subtitle">Overview</strong>

                                    </li>
                                    <li> <p>Fabinsta has a simple and hassle-free exchange policy for Indian orders. We ensure that every transaction at our website is seamless, and we take great care in delivering our products and adhere to the highest quality standards.</p>
                                        <p>We do not accept returns or refunds; however, customers can get the products exchanged within 4 days of receiving the parcel.</p>
                                    </li>
                                    <ul className='p indented'>

                                        <li className='disc'>In case of an exchange, please drop us an email at <a href="support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}> support@fabinsta.com</a>, or initiate return from your login on the website.
                                        </li>
                                        <li className='disc'>Exchange requests will only be entertained if the product returned after approval and passes the quality check and is returned in original condition.
                                        </li>
                                    </ul>

                                </div>
                                <div className='p'>
                                        <strong className="subtitle">RETURN FOR INDIAN ORDERS</strong>
                                    <div className='headline c-primary'> The following conditions must be fulfilled: </div>
                                    <ul className='p indented'>

                                        <li className='disc'>If the customer is unsatisfied with the product delivered, then he/she needs to mail us at <a href="support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}> support@fabinsta.com</a> within 4 days from the date of receiving the consignment or initiate a return from the website. We do not provide refunds solely based on the product not meeting your expectations in terms of quality.
                                        </li>
                                        <li className='disc'>Failure to contact within the time limit may lead to the rejection for the exchange request.
                                        </li>
                                        <li className='disc'>After the exchange request is approved, Fabinsta shall not be held liable for any damage or loss caused to the product during transit. The reverse logistics will be charged for the transporter and handling charges.
                                        </li>
                                        <li className='disc'>Refund and exchange amount will be calculate based on the actual quantity received less discount and offer given and any amount paid to reverse transport and handling charges.
                                        </li>
                                        <li className='disc'>Final credit to your account will be given after our final inspection of goods. If not found satisfactory or some other fabric then approves for return, we will send back goods at your cost.
                                        </li>
                                        <li className='disc'>Reverse pick-up is not available.
                                        </li>
                                        <li className='disc'>Please ensure that the exchange rolls are securely packed to avoid further damage of goods in transit. If the goods are incomplete/ damaged, the goods will not be replaced. It’s advisable to make a video of packaging the rolls.
                                        </li>
                                        <li className='disc'>Items to be exchanged must be unused, unworn, unwashed, and undamaged. Any items that have been damaged, soiled, or altered will not be accepted and will be sent back to the customer. No exchanges will be accepted for the following items:
                                        </li>
                                        <li className='disc-2'>i)Customized orders</li>
                                        <li className='disc-2'>ii)Products on sale</li>
                                        <li className='disc-2'>iii)Already exchanged orders</li>
                                        <li className='disc'>The customer agrees not to dispute the decision made by Fabinsta and accept the decision regarding the return validation in case the product is unacceptable for return.
                                        </li>
                                        <li className='disc'>Non-Valid exchange will be sent back to the customer and the said customer will be blacklisted for future purchases.
                                        </li>
                                        <li className='disc'>Once the product is received, a standard quality check is done, and if the exchange is due to an error on our part (incorrect item sent, damaged/defective product), we will replace the product.
                                        </li>
                                        <li className='disc'>If the product is found unfit for exchange after a quality check, we will send the goods back to you.
                                        </li>
                                        <li className='disc'>Processing and closing of an exchange issue may take at least 10-15 business days or more at our end.
                                        </li>
                                        <li className='disc'>If you are not the actual purchaser but received the product from some FABINSTA customer (such as a gift), you will have to request FABINSTA customer to initiate the exchange for you.
                                        </li>
                                        <li className='disc'>Note – If you purchase a product from any Sale or Offer then that product is not eligible for exchange until and unless the product you have received differs from the one that you ordered. We do not give any refund or return on our products bought from Sale or an Offer.
                                        </li>
                                    </ul>

                                </div>
                                <div className='p'>
                                    <li>
                                        <strong className="subtitle">CANCELLATION FOR INDIAN ORDERS</strong>

                                    </li>
                                    <li> <p>We do not offer cancellations on any orders. No cancellation will be accepted for the following items:</p>
                                    </li>
                                    <ul className='p indented'>
                                        <li className='disc'>Customized orders
                                        </li>
                                        <li className='disc'>Products on sale
                                        </li>
                                        <p>The customer agrees not to dispute the decision made by FabInsta and accept the decision regarding cancellations</p>
                                    </ul>



                                </div>
                                <div className='p'>
                                    <li>
                                        <strong className="subtitle">REFUND PROCESS</strong>

                                    </li>
                                    <li> <p>Store Credits – An official confirmation will be shared on mail with the amount value. You can use this credit amount within one year from the date of issue on the website or store during your next purchase with us. Store Credit will be issued only after we receive the product and it passes our quality check.</p>
                                        <p></p>
                                    </li>


                                </div>
                                <div className='p'>
                                    <li>
                                        <strong className="subtitle">CANCELLATION BY FabInsta</strong>

                                    </li>
                                    <li> <p>Please note that there may be certain orders that we are unable to accept/fulfill and must cancel. We reserve the right at our sole discretion to refuse or cancel any order for any reason.</p>
                                        <p>Some situations that may result in your order being canceled include limitations on quantities available for purchase, inaccuracies or errors in product or pricing information, or problems identified by our credit and fraud analysis department.</p>
                                        <p>We may also require additional verification or information before accepting any order. Our team will inform you if a portion of your order is canceled or if additional information is required to accept your order.</p>
                                        <p>If your order is cancelled after receiving payment the said amount will Refunds shall be credited to the original payment method used by the payer.</p>
                                        <p>The customer agrees not to dispute the decision made by Fabinsta and accepts the decision regarding the cancellation.</p>
                                    </li>


                                </div>
                                <div className='p'>
                                    <li>
                                        <strong className="subtitle">IN CASE OF ANY CONFUSION, PLEASE CONTACT US </strong>

                                    </li>
                                    <li> <p><a href="support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}> support@fabinsta.com</a></p>
                                    </li>

                                </div>
                                <div className='p'>
                                    <li>
                                        <strong className="subtitle">Exchanges</strong>

                                    </li>
                                    <li> <p>We will exchange your fabrics in the unlikely event that you have received damaged, defective, or incorrect fabrics. Exchange for critical damages to the product, such as torn fabric or critical shortage , can be requested within 4 days after delivery.</p>
                                        <p>Please  If this is the case, please email us at <a href="support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}> support@fabinsta.com</a> immediately within 4 days of receiving your goods.</p>
                                    </li>
                                </div>
                                <div className='p'>
                                        <strong className="subtitle">Conditions</strong>
                                    <ul> <li className='disc'>We cannot issue refund or exchange for products that have been cut. To be eligible for a refund, the products must be returned in their original condition.</li>
                                        <li className='disc'>We are unable to issue refunds or exchange for orders 4 days after delivery has been confirmed.</li>
                                        <li className='disc'>We do not provide refunds or exchange solely based on the product not meeting your expectations in terms of quality. </li>
                                        <li className='disc'>We do not exchange solely because there is variation in GSM.     </li>
                                        <li className='disc'>We don’t exchange solely because there lot to lot shade variation.   </li>
                                        <li className='disc'>Compensation for critical damages to the product, such as torn fabric or critical shortage of amount, can be requested within 4 days after delivery. After approval and getting back goods we will send only if other lots are available or a refund will be processed.  </li>
                                        <li className='disc'>Colour differences due to dye-lot variations do not count as defective or incorrect. We may notify you regarding dye-lot variations beforehand if there is a significant difference. </li>
                                    </ul>
                                </div>
                                <div className='p'>
                                        <strong className="subtitle">Refund Methods</strong>
                                    <ul> <li className='disc'>Refunds shall be credited to the original payment method used by the payer.</li></ul>
                                </div>
                                <div className='p'>
                                    <li>
                                        <strong className="subtitle"> CLAIMS</strong>

                                    </li>
                                    <li> <p>Knitted fabric which is sold by kgs we give you meter per kgs based on standard calculation based on GSM (grams per sq/mts). GSM cannot be control there is a possibility gsm may vary +/-10% which may lead to shortage or excess of meter or difference in hand feel of fabric. Fabinsta or seller will not entertain such claim , for your garments order we suggest you to at least order 7% more quantity then your calculated consumption quantity of garments order. </p>
                                    </li>

                                    <div>For detailed information, please refer to our  <span style={{ textDecoration: "underline", color: "#8BC53F", cursor: "pointer" }} onClick={() => navigate('/terms-and-conditions')}>Terms and Conditions.</span></div>


                                </div>

                            </div>
                          
                            <div className='policy-shipping section-policy checkout-section-box'>
                                <div className="p-header">Shipping Policy</div>
                                <div className='p'>
                                    <p>The words in which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in the plural.</p>
                                    <br /> <div className="subtitle">Definitions</div>
                                    <div className='headline c-primary'>
                                        For the purposes of this Disclaimer:
                                    </div>
                                    <li className='disc'>
                                        “Company” (referred to as either “the Company”, “We”, “Us” or “Our” in this Disclaimer) refers to FabInsta.
                                    </li>
                                    <li className='disc'>“Goods” refers to the items offered for sale on the Service.
                                    </li>
                                    <li className='disc'>“Orders” means a request by You to purchase Goods from Us.
                                    </li>
                                    <li className='disc'>“Service” refers to the Website.
                                    </li>
                                    <li className='disc'>“Website” refers to FabInsta, accessible from<a href="support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}> support@fabinsta.com</a>
                                    </li>
                                    <li className='disc'>“You” means the individual accessing the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
                                    </li>
                                    <p>Thank you for visiting and shopping at FabInsta Online Store. The following terms and conditions constitute our Shipping Policy.</p>

                                </div>

                                <div className='p'>
                                    <div className="subtitle">Domestic Shipping Policy</div>
                                    <div className='headline c-primary'>
                                        Shipment Processing Times
                                    </div>
                                    <ul className='indented'>
                                        <li className='disc'>
                                            All orders are processed within the agreed business days for all B2B orders. Orders are not shipped or delivered on weekends or holidays, although, there may be considerations for special cases on request.
                                        </li>
                                        <li className='disc'>
                                            Normally, the order delivery duration is 7 to 10 business days. If We are experiencing a high volume of orders, shipments may be delayed by a few days. Please allow additional days in transit for delivery. If there is a significant delay in the shipment of Your Order, We will contact You via email or telephone.
                                        </li>
                                    </ul>
                                    <div className='headline c-primary'>
                                        Shipping Rates & Delivery Estimates
                                    </div>
                                    <ul className='indented'>
                                        <li className='disc'>
                                            Shipping charges for Your Orders will be calculated and displayed at checkout. Delivery delays can occasionally occur.
                                        </li>

                                    </ul>
                                    <div className='headline c-primary'>
                                        Shipment Confirmation & Order Tracking
                                    </div>
                                    <ul className='indented'>
                                        <li className='disc'>For B2B orders, you can track it on the FabInsta platform with a registered log in.
                                        </li>

                                    </ul>
                                    <div className='headline c-primary'>Customs, Duties and Taxes
                                    </div>
                                    <ul className='indented'>
                                        <li className='disc'>FabInsta is not responsible for any customs and taxes applied to Your Order. All fees imposed during or after shipping are the responsibility of the customer (tariffs, taxes).
                                        </li>

                                    </ul>
                                    <div className='headline c-primary'>Damages
                                    </div>
                                    <ul className='indented'>
                                        <li className='disc'>FabInsta is not liable for any products damaged or lost during shipping. If You received Your Order damaged, please contact the shipment carrier to file a claim.
                                        </li>
                                        <li className='disc'>Please save all packaging materials and damaged goods before filing a claim.
                                        </li>
                                        <li className='disc'>To know about our Returns Policy, <a href="/shipping#return-policy-india">Click here</a>

                                        </li>

                                    </ul>
                                    <div className='headline c-primary'>Contact Us
                                    </div>
                                    <ul className='indented'>
                                        <li className='disc'>If you have any questions about this Shipping Policy, You can contact Us:</li>
                                        <li className='disc'>By visiting this page on our website:<a href="support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}>support@fabinsta.com</a>
                                        </li>
                                        <li className='disc'>By sending us an email:<a href="support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}> support@fabinsta.com </a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='second required'>
                    <div className='conditional-sticky' style={{ top: 'calc(16px + var(--app-header-height))', position: 'sticky', marginTop: '0px', zIndex: '2' }}>
                        <div className='cart-price-summary card-price-summary'>
                            <div className='cart-price-summary card-price-summary'>
                                <div className='header'>{getCartType()}</div>
                                <div className='subtotal-explanation'>
                                    <div className='row'>
                                        <div className='key'>Subtotal ({cartInfo.subTotal} {cartInfo.subTotal <= 1 ? 'Product' : 'Products'})</div>
                                        <div className='value'>{getCartType() !== "Swatch Cart" ? `₹ ${subtotall.toFixed(2)}` : `${subtotall.toFixed(2)} points`}</div>
                                    </div>
                                    {/* <div className='shipping-fee row'>
                                        <div className="key">Shipping</div>
                                        <div className="value">₹ {cartInfo.shipping}</div>

                                    </div> */}
                                </div>
                                <div className='total'>
                                    {getCartType() === "Swatch Cart" && (
                                         <div className='total'>
                                   {/* { profile?.loyaltyAmount > subtotall ? (<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", color: "gray" }}>

                    <div style={{ display: "flex", flexDirection: "column" }}> {subtotall < loyalty?.minRedeemPoints && (<span style={{ fontSize: "12px", color: "red" }}>
                    Subtotal points should more than or equal to min redeem points</span>)}
                    {subtotall >= loyalty?.minRedeemPoints && (  <span style={{ fontSize: "12px", display: "flex", justifyContent: "flex-end" }}>
                        subtotal {subtotall.toFixed(2)} reduced from loyalty {profile?.loyaltyAmount.toFixed(2)}</span> )}</div></div>
                  ) : (<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", color: "red" }}><span style={{ fontSize: "12px" }}>
                    Not enough loyalty points to place order</span> </div>)} */}
                    
                    </div>)}
                                    <div className='row'>
                                        <div className='key'>
                                            Total
                                        </div>
                                        <div className="value">{getCartType() !== "Swatch Cart" ? `₹ ${subtotall.toFixed(2)}` : `${subtotall.toFixed(2)} points`}</div>
                                    </div>
                                </div>

                                {/* <div className='estimated-delivery'>
                                    <div className='label'>
                                        Estimated Delivery
                                    </div>
                                    <div className='value'>Sep 17, 2024</div>

                                </div> */}

                            </div>
                        </div>

                        <div className='agreement'>
                            <div className='checkout-optional-sections'>
                                <div style={{ display: 'flex', flexDirection: "row" }}>
                                    <div style={{ display: 'flex', alignItems: "center" }}>
                                        <Checkbox
                                            checked={checkboxCheck}
                                            onChange={handleCheckboxChange}
                                        />
                                    </div>
                                    <div style={{ marginLeft: "10px", fontWeight: "bold" }}>I have read and agree with the terms and conditions</div></div>

                                {deliveryModeError && (
                                    <>
                                        <div style={{ display: "flex" }}>
                                            <span style={{ color: "gray", fontWeight: "bold", marginRight: "3px", fontSize: "14px" }}>NOTE : </span>
                                            <span style={{ display: "flex", color: "red", marginTop: "0px" }}>
                                                Please Accept the Terms and Conditions
                                            </span></div> </>
                                )}
                            </div>
                        </div>
                        {/* <div>
                            {<span style={{ color: 'gray' }} ><span style={{ color: 'red' }}>Note : </span>Please Scroll down to Read the policy</span>}
                        </div> */}
                        {(
                            <div className='flex g-8'>
                                <B2BButton name={"Continue to review order"} color={"#8BC53F"} style={{ fontWeight: 600, height: '48px', boxShadow: '0 3px 6px 0 rgba(0,0,0,.16)' }}
                                    onClick={handleButtonClick}
                                />
                            </div>
                        )}
                    </div>

                </div>


            </div>
        </>
    )
}